import {
    faInfo,
    faCalendar,
    faFileInvoice,
    faCreditCard,
    faUsers,
    faUser,
    faClock,
} from "@fortawesome/free-solid-svg-icons";

import InvoiceTemplate from "../../../components/clinic/InvoiceTemplate";
import PaymentDetails from "../../../components/clinic/PaymentDetails";
import OnlineBookings from "../../../components/clinic/OnlineBookings";
import Details from "../../../components/clinic/Details";
import PatientHistoryTemplate from "../../../components/clinic/PatientHistoryTemplate";
import Login from "../../../components/clinic/Login";
import ScreenWithTabs from "../../../components/general/auxiliar/ui/ScreenWithTabs";
import Schedule from "../../../components/clinic/Schedule";

const ClinicSettings = () => {
    const tabs = [
        {
            id: "clinic-details",
            name: "Detalles de la clínica",
            smallName: "Detalles",
            icon: faInfo,
            component: <Details />,
        },
        {
            id: "clinic-schedule",
            name: "Horario de la clínica",
            smallName: "Horario",
            icon: faClock,
            component: <Schedule />,
        },
        {
            id: "online-bookings",
            name: "Reservas Online",
            smallName: "Reservas",
            icon: faCalendar,
            component: <OnlineBookings />,
        },
        {
            id: "patient-history-template",
            name: "Plantilla de Historia Clínica",
            smallName: "Historia Clínica",
            icon: faUsers,
            component: <PatientHistoryTemplate />,
        },
        {
            id: "bills",
            name: "Plantilla de Facturas",
            smallName: "Facturas",
            icon: faFileInvoice,
            component: <InvoiceTemplate />,
        },
        {
            id: "login-details",
            name: "Perfiles de Acceso",
            smallName: "Perfiles",
            icon: faUser,
            component: <Login />,
        },
        {
            id: "payment",
            name: "Detalles de Pago",
            smallName: "Pago",
            icon: faCreditCard,
            component: <PaymentDetails />,
        },
    ];

    return <ScreenWithTabs srTitle="Configuración de la Clínica" tabs={tabs} />;
};

export default ClinicSettings;
